import { makeAutoObservable } from "mobx";

class Swiper {
  transform = { x: 0, y: 0, rotate: 0 };
  opacityCard = 1;

  // direction swipe.
  // swiping by mouse/touch
  isToTop = false;
  isToRight = false;
  isToLeft = false;

  isPositive = false;
  isNegative = false;
  isNeutral = false;

  isContinueSwiping = false;

  constructor() {
    makeAutoObservable(this);
  }

  setOpacityCard(opacity) {
    this.opacityCard = opacity;
  }

  setTransform(transform) {
    this.transform = transform;
  }

  setIsToRight(value) {
    this.isToRight = value;
  }
  setIsToLeft(value) {
    this.isToLeft = value;
  }
  setIsToTop(value) {
    this.isToTop = value;
  }
  setIsPositive(value) {
    this.isPositive = value;
  }
  setIsNegative(value) {
    this.isNegative = value;
  }
  setIsNeutral(value) {
    this.isNeutral = value;
  }

  setIsContinueSwiping(value) {
    this.isContinueSwiping = value;
  }
}

export default new Swiper();
